import { sendPost } from "src/utils/sendApi"

export const getChemDrawApi = sendPost("v1/data/_get_chem_draw_data")
export const saveChemDrawApi = sendPost("v1/data/_save_chem_draw")
